import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Message from 'components/Message';
import Button from 'components/Button';
import ProgressionListItem from 'components/Progression/ProgressionListItem';
import ModalPlayer from 'components/ModalPlayer';
import { Paragraph } from 'components/Common/Typography';
import { BlockSpace } from 'components/Common/Spacing';
import { CenterBoth } from 'components/Common/Layout';

import { search } from 'actions/progression';

import styles from './Progressions.css';

const LIMIT = 10;

export default function Progressions() {
  useStyles(styles);
  const dispatch = useDispatch();
  const { progressions, progressionSlug, error, pagination } = useSelector(
    state => state.progression,
  );

  const getProgressions = async () => {
    await dispatch(search({ query: { populate: true, limit: LIMIT } }));
    // const {
    //   payload: { progressions, parsed },
    // } = response;
    // progressions && progressions.forEach((progression, index) => {
    //   const parsedProgression = parsed[progression._id].progression;
    //   dispatch(initProgression({
    //     id: progression._id,
    //     progressionSettings: progression.settings,
    //     parsedProgression,
    //   }))
    // });
  };

  useEffect(() => {
    getProgressions();
  }, []);

  const loadMoreProgressions = () => {
    if (!pagination) return;
    dispatch(
      search({
        query: {
          page: pagination.currentPage + 1,
          limit: LIMIT,
          populate: true,
        },
        append: true,
      }),
    );
  };

  const List =
    progressions &&
    progressions.map(progression => {
      return (
        <ProgressionListItem
          basePath="discover"
          key={progression._id}
          progression={progression}
          showUser
        />
      );
    });

  return (
    <div>
      {error && <Message messageType="error">{error}</Message>}
      {progressionSlug && <ModalPlayer progressionSlug={progressionSlug} />}
      <CenterBoth>
        <Paragraph heirarchy="secondary">
          <span className={styles.eighthNoteIcon}>&#9834;</span>
          &nbsp;Discover musical ideas, phrases, compositions and song chords
          from users around the world.
        </Paragraph>
      </CenterBoth>
      <BlockSpace size={200} />
      {List}
      <Button onClick={loadMoreProgressions} buttonType="grey">
        Show More Progressions
      </Button>
    </div>
  );
}
